import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

const styles = (theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: `${theme.palette.background.default} !important`,
    padding: theme.spacing(1.5),
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
    '&$focused': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.primary.main,
    },
  },
  icon: {
    marginRight: theme.spacing(1.1),
    top: '50%',
    transform: 'translateY(-50%)',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    paddingRight: `${theme.spacing(4)}px !important`,
  },
});

const useStyles = makeStyles((theme) => ({
  squareSelect: {
    borderRadius: 0 + '!important',
  },
  fullWidth: {
    width: '100%',
  },
}));

const Select = (props) => {
  const styles = useStyles();
  const [selectValue, setSelectValue] = React.useState(
    props.defaultValue || '',
  );
  const {
    id = 'demo-simple-select',
    label = '',
    labelId = 'demo-simple-select-label',
    list = [],
    placeholder = '',
    emptyOption,
    emptyOptionLabel,
    onChange = setSelectValue,
    value = selectValue,
    disableUnderline = true,
    square = false,
    fullWidth = false,
    menuItemProps = {},
    classes,
    helperText = '',
    error = false,
    ...rest
  } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };
  return (
    <>
      {label && (
        <InputLabel id="demo-simple-select-disabled-label">{label}</InputLabel>
      )}
      <MaterialSelect
        labelId={labelId}
        id={id}
        classes={classes}
        value={value}
        className={clsx({
          [styles.squareSelect]: square,
          [styles.fullWidth]: fullWidth,
        })}
        onChange={handleChange}
        MenuProps={{
          PopoverClasses: { paper: clsx({ [styles.squareSelect]: square }) },
        }}
        disableUnderline={disableUnderline}
        {...rest}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {placeholder}{' '}
          </MenuItem>
        )}
        {emptyOption && (
          <MenuItem value="">
            <em>{emptyOptionLabel}</em>
          </MenuItem>
        )}
        {list.map((item, index) => {
          const { label = 'no label', value = null } = item;
          return (
            <MenuItem value={value} key={index} {...menuItemProps}>
              {label}
            </MenuItem>
          );
        })}
      </MaterialSelect>
      {(error || helperText) && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </>
  );
};

Select.propTypes = {
  emptyOption: PropTypes.bool,
  emptyOptionLabel: PropTypes.string,
};

Select.defaultProps = {
  emptyOption: false,
  emptyOptionLabel: 'None',
};

export default withStyles(styles)(Select);
